import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '@/views/Login'
import Layout from '@/views/Layout'

// 路由懒加载，写成函数的格式 webpack打包的时候，
// 看到这个标识就不会不加载这个js文件
// webpackChunkName 用来 指明 打包后 生成的文件名

// 门店
const Activity = () => import(/* webpackChunkName: 'User' */ '@/views/Layout/Activity/index');
const ActivityProduct = () => import(/* webpackChunkName: 'User' */ '@/views/Layout/Activity/ActivityProduct.vue');
const RewardRecord = () => import(/* webpackChunkName: 'User' */ '@/views/Layout/Activity/RewardRecord.vue');
const PrizeDetail = () => import(/* webpackChunkName: 'User' */ '@/views/Layout/Activity/PrizeDetail.vue');

Vue.use(VueRouter)

const routes = [
  {
    // 根路径 的 重定向
    path: '/',
    redirect: '/login'// 重定向
  },
  {
    // 登录页
    path: '/login',
    component: Login,
    meta: {
      title: 'Login'
    }
  },
  {
    // 首页
    path: '/layout',
    component: Layout,
    // redirect: '/layout/home',
    redirect: '/login',
    children: [
      // {
      //   // path: '', 或者 重定向
      //   path: 'home',
      //   component: Home,
      //   meta: { // 给路由对象添加额外的信息
      //     scrollY: 0,
      //     title: 'Store'
      //   }
      // },
      // {
      //   // path: '', 或者 重定向
      //   path: 'storeMap',
      //   component: StoreMap,
      //   meta: { // 给路由对象添加额外的信息
      //     scrollY: 0,
      //     title: 'Store Map'
      //   }
      // },
    ]
  },
  {
    path: '/activity',
    component: Activity,
    meta: {
      title: 'Activity'
    }
  },
  {
    path: '/activityProduct',
    component: ActivityProduct,
    meta: {
      title: 'Activity Product'
    }
  },
  {
    path: '/prizeDetail',
    component: PrizeDetail,
    meta: {
      title: 'Prize Detail'
    }
  },
  {
    path: '/rewardRecord',
    component: RewardRecord,
    meta: {
      title: 'Reward Product'
    }
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior: () => ({ y: 0 })
})

router.afterEach((to) => {
  // if (typeof window.gtag === 'function') {
  //   gtag('config', 'G-XTF0LRE0J4', {
  //     page_path: to.fullPath,
  //     page_title: to.meta.title || 'untitled_page'
  //   })
  // } else {
  //   console.log('gtag not loaded, skipping analytics tracking')
  // }
})

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title ? to.meta.title : 'Promotion'
  next()
})

// 路由重复跳转问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
